import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    // Needed for hash routing
    path: 'error',
    redirectTo: '/machine-dashboard',
    pathMatch: 'full',
  },
  {
    // Needed for hash routing
    path: 'state',
    redirectTo: '/machine-dashboard',
    pathMatch: 'full',
  },
  {
    // Needed for hash routing
    path: 'code',
    redirectTo: '/machine-dashboard',
    pathMatch: 'full',
  },
  {
    path: 'machine-dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
    canActivate: [MsalGuard],
  },
  {
    path: 'overview/:id',
    canActivate: [MsalGuard],
    loadComponent: () => import('./features/machine-overview/machine-overview.component').then((m) => m.MachineOverviewComponent),
    children: [
      {
        path: '',
        loadChildren: () => import('./features/machine-overview/machine-overview.routes').then((m) => m.machineOverviewRoutes),
      },
    ],
  },
  {
    path: 'report',
    loadComponent: () => import('./features/reports/reports.component').then((m) => m.ReportsComponent),
  },
  {
    path: '**',
    redirectTo: '/machine-dashboard',
    pathMatch: 'full',
  },
];
